import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api-service/api-service';
import { API } from '../../API';

export interface Codification {
  codification_id: number;
  codification_code: string;
  codification_label: string;
  codification_label_ara?: string;
  codification_order: number;
  codification_color_text?: string;
  codification_color_bg?: string;
}

@Injectable({ providedIn: 'root' })
export class CodificationsService {
  constructor(private apiService: ApiService) {}

  getCodificationsByGroup(group: string): Observable<{ success: boolean; data: Codification[] }> {
    return this.apiService.post(API.CODIFICATIONS.GET_BY_GROUP, { group });
  }
}
